import { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import Page from '@/components/content/Page'
import { useText } from '@/components/i18n/hooks'
import { Translation } from '@/components/i18n/Translation'
import LoaderCircle from '@/components/util/LoaderCircle'
import { createNewOrder, setShopState } from '@/ducks/shopOrderReducer'
import {
  getActiveStepId,
  getFurthestStepId,
  getStepIdOfMainProduct,
} from '@/ducks/shopProgressReducer'
import { getQuote } from '@/ducks/shopQuotesReducer'
import withShopQuotesLoaded from '@/hocs/withShopQuotesLoaded'
import { useMountEffect } from '@/hooks/mounting-hooks'
import { useLocalDate } from '@/hooks/use-local-date'

import ProgressBar from './ProgressBar'
import ProgressButtons from './ProgressButtons'
import QuoteSummary from './QuoteSummary'
import Step from './steps/Step'

import './shop-quote-page.scss'

const ShopQuotePage = () => {
  const [isSetUp, setIsSetup] = useState(false)
  const { formatDate } = useLocalDate()

  const params = useParams()
  const orderId = params.order_id

  const activeStepId = useSelector(getActiveStepId)
  const furthestStepId = useSelector(getFurthestStepId)
  const stepIdOfMainProduct = useSelector(getStepIdOfMainProduct)

  const newQuoteText = useText('new quote')

  const dispatch = useDispatch()

  const tempOrder = useSelector(state => getQuote(state, orderId))

  useMountEffect(() => {
    if (tempOrder) {
      const { order, progress, created_date } = tempOrder
      // @ts-ignore
      dispatch(setShopState(order, progress, orderId, created_date))
    } else {
      // @ts-ignore
      dispatch(createNewOrder(`${newQuoteText} - ${formatDate({ date: new Date() })}`))
    }
    setIsSetup(true)
  })

  if (!isSetUp) {
    return (
      <Page className="shop">
        <LoaderCircle />
      </Page>
    )
  }

  return (
    <Page className="shop">
      <h1>
        <Translation id="Quote" />
      </h1>

      <ProgressBar />

      <div className="shop-content">
        <MainContent />

        {activeStepId >= stepIdOfMainProduct && <QuoteSummary />}
      </div>

      {furthestStepId >= stepIdOfMainProduct && <ProgressButtons />}
    </Page>
  )
}

const MainContent = () => (
  <div className="shop-content__main">
    <Step />
  </div>
)

export default withShopQuotesLoaded(ShopQuotePage)
